<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：推荐图片-编辑
    -->
    <div v-loading="loading" class="goods-add pb50">
        <!--编辑推荐图片-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">编辑推荐图片</div>
            <el-form-item label="推荐图片">
                <div>
                    <el-button type="primary" @click="openUpload">上传图片</el-button>
                    <div v-if="form.file_path != ''" class="img">
                        <img :src="form.file_path" width="100" />
                    </div>
                </div>
            </el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Upload from "@/components/file/Upload";
    export default {
        components: {
            /*图片上传*/
            Upload: Upload,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*是否上传图片*/
                isupload: false,
                form: {
                    activity_goods_id: "",
                    activity_id: "",
                    image_id: "",
                    file_path: "",
                },
                /*验证规则*/
                rules: {
                    image_id: [{ required: true, message: "请上传图片", trigger: "blur" }]
                }
            };
        },
        created() {
            this.getDetail();
        },

        methods: {
            /*上传*/
            openUpload() {
                this.isupload = true;
            },

            /*获取图片*/
            returnImgsFunc(e) {
                let self = this;
                if (e != null) {
                    this.form.image_id = e[0].file_id;
                    this.form.file_path = e[0].file_path;
                }
                console.log(this.form)
                this.isupload = false;
            },

            getDetail() {
                let self = this;
                // 取到路由带过来的参数
                const params = self.$route.query.activity_goods_id;
                PlatformActivityApi.goods.detailgoods({ activity_goods_id: params }, true)
                    .then((res) => {
                        self.form = res.data.detail;
                        self.form.activity_id = res.data.detail.activity_id;
                        if (!self.form.image) {
                            self.form.image = {};
                        }
                        self.form.image_id = res.data.detail.image.file_id;
                        self.form.file_path= res.data.detail.image.file_path;
                        self.loading = false;
                    })
                    .catch((error) => {});
            },

            /*修改*/
            onSubmit() {
                let self = this;
                let params = this.form;
                // 取到路由带过来的参数
                PlatformActivityApi.goods.editimggoods(params, true)
                    .then((data) => {
                        self.$message({
                            message: data.msg,
                            type: "success"
                        });
                        self.$router.push({
                            path: "/platformactivity/goods/index",
                            query: {
                                activity_id: params.activity_id
                            }
                        });
                    })
                    .catch((error) => {});
            },

            /*取消添加，返回列表*/
            cancelFunc() {
                this.$router.back(-1);
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/goods/edit.vue